import React from "react"

import { FormControl, FormHelperText, FormLabel, Textarea } from "@mui/joy";
import { Icon } from '../../assets';
import { useTranslation} from 'react-i18next';

const InputTextarea = (props) => {
    const {t} = useTranslation();

    const {
        editing,
        required,
        name,
        label,
        autoFocus,
        placeholder,
        hint,
        icon,
        haserror,
        disabled,
        minrows,
        className = "",
        value,
        onChange,
        error,
    } = props;
    let { readonly } = props;
    if (!editing) readonly = true;

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (haserror) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    const invalid = Boolean(error);

    return (
        <div className={("form-element textarea " + className).trim()}>
            <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                {label ? <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel> : null}
                <Textarea
                    id={name}
                    name={name}
                    value={value}
                    error={invalid}
                    onChange={onChange}
                    variant="outlined"
                    autoComplete="off"
                    autoFocus={autoFocus}
                    placeholder={t(placeholder)}
                    disabled={disabled}
                    readOnly={readonly}
                    required={required}
                    minRows={minrows}
                    startDecorator={(icon) ? (
                        <Icon icon={icon} />
                    ) : (
                        <></>
                    )}
                    endDecorator={(haserror || error) ? (
                        <Icon icon="faCircleExclamation" />
                    ) : (
                        <></>
                    )}
                />
                <FormHelperText className="form-element-hint">
                    {(haserror || error) ? (
                        <>
                            {error ? error.message : 'Messaggio di errore'}
                        </>
                    ) : (
                        <>
                            {hint}
                        </>
                    )}
                </FormHelperText>
            </FormControl>
        </div>
    );
};


export default InputTextarea;
